import { createWebSupportHomeEventFactory } from '@spotify-internal/ubi-sdk-support-spotify-com-web-support-home';
import { useMemo } from 'react';

import { PageId } from 'utils/ubi/pageId';

import { useUbiPage } from '../useUbiPage';
import { useUbiContext } from '../ubiProvider';

const pageId = PageId.Home;

export const useUbiHomePage = () => {
  const ubiLogger = useUbiContext();
  const { pageFactory } = useUbiPage(pageId, '', createWebSupportHomeEventFactory);
  return useMemo(
    () => ({
      logLoginButtonImpression: () => ubiLogger.logImpression(pageFactory.loginButtonFactory().impression()),
      logLoginButtonHit: (destination: string) =>
        ubiLogger.logInteraction(pageFactory.loginButtonFactory().hitUiNavigate({ destination })),
      logSearchInputFocus: () => ubiLogger.logInteraction(pageFactory.searchInputFactory().hitFocusInputField()),
      logSearchResult: (articleSlug: string, position: number) =>
        pageFactory.searchResultFactory({
          identifier: articleSlug,
          position,
        }),
      logQuickLink: (articleSlug: string, position: number) =>
        pageFactory.quickLinkContainerFactory().quickLinkFactory({
          identifier: articleSlug,
          position,
        }),
      logSearch: (searchQueryString: string) =>
        ubiLogger.logInteraction(pageFactory.searchInputFactory().keyStrokeChangeSearchQuery({ searchQueryString })),
      logCategoryCardLink: (parentCategorySlug: string, position: number) =>
        pageFactory.parentCategoryCardContainerFactory().parentCategoryCardLinkFactory({
          identifier: parentCategorySlug,
          position,
        }),
      logCommunityLink: (destination: string) =>
        ubiLogger.logInteraction(
          pageFactory.communityLinkFactory().hitUiNavigate({
            destination,
          }),
        ),
    }),
    [pageFactory, ubiLogger],
  );
};

export type UbiHomePage = ReturnType<typeof useUbiHomePage>;
